import Swipers from "./swiper";

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Swipers
     */
    const swipers = new Swipers({});
    swipers.init();
});
